import styled from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

//components
import { Section, SectionTitle } from '@/containers-ai/SectionHeading';

export const FaqSection = styled(Section)`
  background: ${homeColor.bg};
`;

export const FaqTitle = styled(SectionTitle)`
  margin: 0 auto 32px;
  max-width: initial;
  text-align: center;
`;

export const FaqList = styled.div`
  display: grid;
  gap: 20px;
  max-width: 920px;
  margin: 0 auto;
`;

export const FaqItem = styled.div`
  border: 1px solid ${homeColor.line2};
  border-radius: 16px;
  padding: 22px 26px;
  background: linear-gradient(
    120deg,
    rgba(0, 215, 215, 0.05),
    rgba(20, 214, 77, 0.06)
  );

  ${screen.lg} {
    padding: 28px 32px;
  }
`;

export const FaqQuestion = styled.h3`
  font-family: ${getToken('font-family-default')};
  font-size: 18px;
  line-height: 1.35;
  font-weight: 700;
  color: ${homeColor.white};
  margin: 0 0 10px;

  ${screen.lg} {
    font-size: 20px;
  }
`;

export const FaqAnswer = styled.p`
  font-family: ${getToken('font-family-default')};
  font-size: 15px;
  line-height: 1.6;
  color: ${homeColor.muted};
  margin: 0;

  ${screen.lg} {
    font-size: 17px;
  }
`;
